import { render, staticRenderFns } from "./linkedWrap.vue?vue&type=template&id=4027b4b4"
import script from "./linkedWrap.vue?vue&type=script&lang=js"
export * from "./linkedWrap.vue?vue&type=script&lang=js"
import style0 from "./linkedWrap.vue?vue&type=style&index=0&id=4027b4b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports